var map = {
	"./BuddhaAkshay/images/Customerlimit.svg": [
		52496,
		496
	],
	"./JanBhavishya/images/Customerlimit.svg": [
		72917,
		917
	],
	"./Suvarna/images/Customerlimit.svg": [
		92743,
		743
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 22173;
module.exports = webpackAsyncContext;